import React from 'react';
import { Card } from '@mui/material';
import PropTypes from 'prop-types';
import relateTime from 'dayjs/plugin/relativeTime';
import dayjs from '../../../utils/functions/thDayjs';

dayjs.extend(relateTime);

const SectionHeader = ({ title, icon }) => (
  <div className="w-full py-3 mt-4 first:mt-0 border-b-2 border-blue-500 text-lg font-bold text-gray-800 flex items-center gap-2">
    {icon && <span className="text-blue-600">{icon}</span>}
    {title}
  </div>
);

const InfoRow = ({ label, value }) => (
  <div className="w-full lg:w-1/2 py-3 px-2 hover:bg-gray-50 rounded-lg transition-colors duration-200">
    <div className="flex flex-col gap-1">
      <div className="text-sm font-medium text-gray-500">{label}</div>
      <div className="text-base font-semibold text-gray-900">
        {value || <span className="text-gray-400 font-normal">ไม่ระบุ</span>}
      </div>
    </div>
  </div>
);

const VehicleAttributeCard = ({ vehicleDetail }) => {
  const { attribute = {}, machine = {} } = vehicleDetail;

  return (
    <Card className="shadow-lg rounded-2xl overflow-hidden border border-gray-100">
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4">
        <h2 className="text-xl font-bold text-white">ข้อมูลเครื่องจักร</h2>
        <p className="text-blue-100 text-sm mt-1">
          รายละเอียดคุณสมบัติและข้อมูลทางเทคนิค
        </p>
      </div>

      <div className="p-6 bg-white">
        {/* เกี่ยวกับเครื่องจักร */}
        <SectionHeader title="เกี่ยวกับเครื่องจักร" icon="🚜" />
        <div className="flex flex-wrap -mx-2">
          <InfoRow
            label="ประเภทเครื่องจักร"
            value={vehicleDetail?.type?.name}
          />
          <InfoRow label="แบรนด์" value={attribute?.brand} />
          <InfoRow label="วันผลิต" value={attribute?.generation} />
          <InfoRow label="เลขตัวถัง" value={attribute?.body_number} />
          <InfoRow label="ปีที่ซื้อ" value={attribute?.buy_year} />
          <InfoRow label="งานที่ใช้" value={machine?.note} />
          <InfoRow
            label="แรงม้า"
            value={machine?.horsepower ? `${machine.horsepower} HP` : null}
          />
        </div>

        {/* เกี่ยวกับมอเตอร์ */}
        <SectionHeader title="เกี่ยวกับมอเตอร์" icon="⚙️" />
        <div className="flex flex-wrap -mx-2">
          <InfoRow label="ยี่ห้อมอเตอร์" value={attribute?.moter?.brand} />
          <InfoRow label="รุ่นมอเตอร์" value={attribute?.moter?.model_name} />
          <InfoRow label="ความจุ" value={attribute?.moter?.capacity} />
          <InfoRow
            label="ความเร็วรอบ"
            value={
              attribute?.moter?.speed ? `${attribute.moter.speed} RPM` : null
            }
          />
        </div>

        {/* เกี่ยวกับเกียร์ */}
        <SectionHeader title="เกี่ยวกับเกียร์" icon="🔧" />
        <div className="flex flex-wrap -mx-2">
          <InfoRow label="ยี่ห้อเกียร์" value={attribute?.gear?.brand} />
          <InfoRow label="รุ่นเกียร์" value={attribute?.gear?.model_name} />
          <InfoRow label="ความจุ" value={attribute?.gear?.capacity} />
          <InfoRow
            label="ความเร็วรอบ"
            value={
              attribute?.gear?.speed ? `${attribute.gear.speed} RPM` : null
            }
          />
        </div>
      </div>
    </Card>
  );
};

VehicleAttributeCard.propTypes = {
  vehicleDetail: PropTypes.object,
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
};

export default VehicleAttributeCard;
